module.exports = __webpack_public_path__ + "img/cjxm.ad5bce44.jpg";